<template>
  <li class="c-sidebar-nav-item">
    <a class="c-sidebar-nav-link" href="javascript:void(0)" @click="handleClick">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        role="img"
        class="c-sidebar-nav-icon"
      >
        <rect
          width="264"
          height="32"
          x="208"
          y="80"
          fill="var(--ci-primary-color, currentColor)"
          class="ci-primary"
        ></rect>
        <path
          fill="var(--ci-primary-color, currentColor)"
          d="M40,96a64,64,0,1,0,64-64A64.072,64.072,0,0,0,40,96Zm64-32A32,32,0,1,1,72,96,32.036,32.036,0,0,1,104,64Z"
          class="ci-primary"
        ></path>
        <rect
          width="264"
          height="32"
          x="208"
          y="240"
          fill="var(--ci-primary-color, currentColor)"
          class="ci-primary"
        ></rect>
        <path
          fill="var(--ci-primary-color, currentColor)"
          d="M104,320a64,64,0,1,0-64-64A64.072,64.072,0,0,0,104,320Zm0-96a32,32,0,1,1-32,32A32.036,32.036,0,0,1,104,224Z"
          class="ci-primary"
        ></path>
        <rect
          width="264"
          height="32"
          x="208"
          y="400"
          fill="var(--ci-primary-color, currentColor)"
          class="ci-primary"
        ></rect>
        <path
          fill="var(--ci-primary-color, currentColor)"
          d="M104,480a64,64,0,1,0-64-64A64.072,64.072,0,0,0,104,480Zm0-96a32,32,0,1,1-32,32A32.036,32.036,0,0,1,104,384Z"
          class="ci-primary"
        ></path>
      </svg>
      Invoice Portal
    </a>
  </li>
</template>

<script>
import { http } from "@/config/httpCommon";

export default {
  name: "InvoicePortalItem",
  methods: {
    async handleClick() {
      try {
        this.$store.commit("set", ["showLoader", true]);
        const response = await http.get(`/stripe-billing-portal`);
        const portalLink = response.data?.result?.billing_portal_link;
        if (portalLink) {
          window.open(portalLink, "_self");
        } else {
          console.error("No billing portal link returned from API");
        }
      } catch (err) {
        console.error("Failed to fetch billing portal link:", err);
      } finally {
        this.$store.commit("set", ["showLoader", false]);
      }
    },
  },
};
</script>
